import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/500px': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M103.3 344.3C96.8 330.1 96.4 326 110.7 321.2 136.3 313.2 118.7 330.4 153.9 370.4H154.2V276.5C155.4 226.3 198.2 184.3 251.9 184.3 305.8 184.3 349.6 227.8 349.6 281.1 349.6 344.5 288.8 394.3 221.1 374.4 210.6 370.2 219 342.7 229.6 345.8 282.6 345.8 319 335.7 319 281.4 319 220.4 241.9 191.8 202.1 236.8 178.6 263.2 184.5 278.9 184.5 394.4 235.2 425.4 302.8 416.4 344.9 374.3 369.7 349.5 383.4 316.3 383.4 281.3 383.4 246.1 369.6 213.1 344.6 188 319.8 163.2 286.8 149.5 251.3 149.5S182.5 163.3 157.8 188C157.5 188.3 141.8 204.5 136.6 211.9L136.1 212.5C132.8 217.2 129.8 221.6 116 218.6 109.1 216.9 101.7 212.8 101.7 206.8V20C101.7 15 105.6 9.5 112.2 9.5H353.5C361.8 9.5 361.8 21.1 361.8 24.6 361.8 28.5 361.8 39.7 353.5 39.7H130.3V172.6H130.6C234.8 62.8 413.4 136.6 413.4 281.5 413.4 459.6 168.6 501.8 103.3 344.3zM166.6 83.5C166.1 87.7 171.2 108 181.2 104.1 306 56.6 384 144.5 390.6 144.5 395.4 144.5 413.4 129.2 404.9 121.7 311.7 32.7 170.4 64.7 166.6 83.5zM393 414.7C283 524.6 94 475.5 61 310.5 61 298.3 30.6 303.1 32.1 313.8 56.1 487.2 278.1 570.7 413.7 435.1 420.6 427.3 401.1 406.7 393 414.7zM213.6 306.6C213.6 310.6 217.9 313.9 219.1 315.1 222.1 318.1 225.2 319.5 227.6 319.5 231.4 319.5 230.2 319.7 249.9 300 269.5 319.3 269 319.5 272.2 319.5 277.6 319.5 290.7 309.1 282.9 301.3L265.6 284 283.8 265.8C290.1 259 273.7 244 267.6 250.1L249.7 268C231.1 249.2 231.3 248.5 228.2 248.5 223.2 248.5 210.2 260.2 215.8 265.8L234 284C215.9 301.9 213.6 303.2 213.6 306.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/500px.js
// module id = MXZ/
// module chunks = 144